import { useEffect, useState } from "react";
import { Headset, TrendingUp, Car, MousePointerClick } from "lucide-react";
import { api } from "@/lib/api";

export function MatchDemandTracker({ compact = false }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/dealer/match-demand").then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  if (!data) return null;
  const since = data.since ? new Date(data.since).toLocaleDateString() : null;

  return (
    <div data-testid="match-demand-tracker" className="tracing-top rounded-2xl border border-[#0A8CF2]/40 bg-gradient-to-b from-[#0A8CF2]/10 to-[#12141C] p-6">
      <div className="flex items-center gap-2 text-[#7FC3FF] text-[11px] font-mono-tech uppercase tracking-widest mb-3">
        <TrendingUp className="h-3.5 w-3.5" /> Specialist Match demand
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div>
          <div className="font-heading text-4xl font-black leading-none" data-testid="match-demand-total">{data.match_requests}</div>
          <div className="text-[11px] text-slate-400 mt-1.5">shoppers asked for a specialist{since ? ` since ${since}` : ""}</div>
        </div>
        <div>
          <div className="font-heading text-4xl font-black leading-none text-[#7FC3FF]" data-testid="match-demand-30d">{data.match_requests_30d}</div>
          <div className="text-[11px] text-slate-400 mt-1.5">in the last 30 days</div>
        </div>
        <div>
          <div className="font-heading text-4xl font-black leading-none text-slate-300" data-testid="match-demand-taps">{data.match_taps}</div>
          <div className="text-[11px] text-slate-400 mt-1.5 flex items-center gap-1"><MousePointerClick className="h-3 w-3" /> "Talk to a specialist" taps</div>
        </div>
      </div>
      <p className="text-xs text-slate-500 mt-4">
        Every one of these is a shopper who wanted to be paired with the right person. With Specialist Match they'd be matched instantly and the specialist would ride inside the CRM lead.
      </p>
      {!compact && data.recent?.length > 0 && (
        <div className="mt-4 border-t border-slate-800 pt-3 space-y-1.5" data-testid="match-demand-recent">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-tech mb-2">Recent</div>
          {data.recent.slice(0, 6).map((r) => (
            <div key={r.id} className="flex items-center gap-2 text-xs text-slate-300">
              {r.kind === "lead" ? <Headset className="h-3.5 w-3.5 text-[#0A8CF2] shrink-0" /> : <MousePointerClick className="h-3.5 w-3.5 text-slate-500 shrink-0" />}
              <span className="truncate flex-1">
                {r.kind === "lead" ? `${r.customer_name || "A shopper"} requested a specialist` : "Shopper tapped \"Talk to a specialist\""}
                {r.vehicle_label && <span className="text-slate-500"> · <Car className="inline h-3 w-3 -mt-0.5" /> {r.vehicle_label}</span>}
              </span>
              <span className="text-slate-500 shrink-0">{new Date(r.created_at).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
